import store from '@/store/index'
import { habitsCollection } from '../../firebase'
import isEmpty from 'ramda/src/isEmpty'
import constants from '@/store/constants'

const SET_HABITS = 'SET_HABITS'
const UPDATE_HABIT = 'updateHabit'
const UPDATE_REORDERED = 'updateReorderedHabits'
const ACCOUNT_TYPES = constants.ACCOUNT_TYPES

class HabitModule {
  habits = {
    get() {
      return store.state.habits
    }
  }

  selectedHabit = {
    get() {
      return store.state.selectedHabit
    },
    set(habit) {
      store.commit('SET_SELECTED_HABIT', habit)
    }
  }

  updateHabit(habit, originalCategory) {
    if (habit.category !== originalCategory) {
      const existingCategory = store.state.habits.filter(
        storeHabit => storeHabit.category === habit.category
      )
      habit.subIndex = existingCategory ? existingCategory.length : 0
      this._resetCategoryIndex(habit, originalCategory)
      return
    }

    this._updateHabit(habit)
  }

  setHabitsOrder(habits, category) {
    const key = category === 'All Habits' ? 'allIndex' : 'subIndex'
    const indexedHabits = this._resetHabitIndex(habits, key)

    if (key === 'subIndex') {
      const updatedStoreHabits = this._mapUpdateStoreHabits(indexedHabits)
      this._commitAndDispatch(
        SET_HABITS,
        updatedStoreHabits,
        UPDATE_REORDERED,
        { habits: indexedHabits }
      )
      return
    }

    this._commitAndDispatch(SET_HABITS, indexedHabits, UPDATE_REORDERED, {
      habits: indexedHabits
    })
  }

  resetHabitsOrder(habitId, category) {
    const categoryHabits = store.state.habits.filter(
      habit => habit.category === category && habit.id !== habitId
    )
    const subIndexedHabits = this._resetHabitIndex(categoryHabits, 'subIndex')
    const updatedStoreHabits = this._mapUpdateStoreHabits(subIndexedHabits)

    const updatedStoreHabitsExcludingHabit = updatedStoreHabits.filter(
      habit => habit.id !== habitId
    )
    const indexedHabits = this._resetHabitIndex(
      updatedStoreHabitsExcludingHabit,
      'allIndex'
    )
    this._commitAndDispatch(SET_HABITS, indexedHabits, UPDATE_REORDERED, {
      habits: indexedHabits
    })
  }

  selectFirstHabit() {
    const habits = this.filteredHabits()
    const habit = habits.length ? habits[0] : null
    if (!habit) return

    store.commit('SET_SELECTED_HABIT', habit)
  }

  filteredHabits() {
    const filteredHabits = store.state.habits.filter(
      habit => habit.category === store.state.selectedCategory
    )
    return filteredHabits.sort(
      (a, b) => parseFloat(a.subIndex) - parseFloat(b.subIndex)
    )
  }

  habitsWithCategory(category) {
    return store.state.habits.filter(habit => habit.category === category)
  }

  reachedHabitsLimit() {
    const userAccount = store.state.user.account
    if (userAccount === ACCOUNT_TYPES.LIFE) return false

    const habitsCount = store.state.habits.length
    return userAccount === ACCOUNT_TYPES.FREE
      ? habitsCount >= 5
      : habitsCount >= 20
  }

  init() {
    if (store.state.habits.length === 0) {
      const habits = []
      habitsCollection
        .where('userId', '==', store.state.user.id)
        .orderBy('category')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            habits.push({ ...doc.data(), id: doc.id })
            store.state.categories.add(doc.data().category)
          })
        })
        .then(() => {
          const sortedHabits = habits.sort(
            (a, b) => parseFloat(a.allIndex) - parseFloat(b.allIndex)
          )
          store.commit('SET_HABITS', sortedHabits)
        })
    }
  }

  _updateHabit(habit) {
    const mappedStoreHabits = this._mapUpdateStoreHabits([habit])
    this._commitAndDispatch(SET_HABITS, mappedStoreHabits, UPDATE_HABIT, {
      habitId: habit.id,
      habit
    })
  }

  _resetCategoryIndex(habit, originalCategory) {
    const originalCategoryHabits = store.state.habits.filter(
      storeHabit =>
        storeHabit.category === originalCategory && storeHabit.id !== habit.id
    )
    if (isEmpty(originalCategoryHabits)) {
      store.state.categories.delete(originalCategory)
      this._updateHabit(habit)
      return
    }
    // redo subIndex of habits within original category
    const indexedHabits = this._resetHabitIndex(
      originalCategoryHabits,
      'subIndex'
    )
    const mappedStoreHabits = this._mapUpdateStoreHabits([
      ...indexedHabits,
      habit
    ])
    this._commitAndDispatch(SET_HABITS, mappedStoreHabits, UPDATE_REORDERED, {
      habits: [...indexedHabits, habit]
    })
  }

  _resetHabitIndex(habits, key) {
    return habits.map((habit, i) => {
      habit[key] = i
      return habit
    })
  }

  _mapUpdateStoreHabits(newHabits) {
    return store.state.habits.map(storeHabit => {
      return (
        newHabits.find(newHabit => newHabit.id === storeHabit.id) || storeHabit
      )
    })
  }

  _commitAndDispatch(commit, commitPayload, dispatch, dispatchPayload) {
    store.commit(commit, commitPayload)
    store.dispatch(dispatch, dispatchPayload)
  }
}

export default new HabitModule()
